var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/IconButton/index.tsx";
import React from 'react';
import { VStack } from '@adc/parallax-component-library';
const IconButton = ({
  children,
  onPress,
  disabled,
  testID,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(VStack, Object.assign({
    testID: testID,
    onPress: onPress,
    disabled: disabled,
    style: {
      cursor: 'pointer'
    }
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }), children);
};
export { IconButton };